import React, {useContext} from 'react';
import {AssistantCar_API} from "./AssistantCar_API";
import StatusCell from "../../../components/Pages/TablePage/Table/Cells/NewCells/StautsCell/StatusCell";
import OrgPage from "../../../components/OrgPage";
import TextCell from "../../../components/Pages/TablePage/Table/Cells/NewCells/TextCell/TextCell";
import LinkCell3 from "../../../components/Pages/TablePage/Table/Cells/LinkCell3/LinkCell3";
import {AuthContext} from "../../../context/AuthContext";

function AllCarSurveysHistory() {
    const {getAllCarSurveys} = AssistantCar_API.errors
    const baseURL = process.env.REACT_APP_BASE_URL
    const {REACT_APP_URL_PREFIX} = process.env
	const userId = useContext(AuthContext)?.token?.userId

    const toOrganizationCallHistory = (props) => {
        const name = props.cellContent
        return <LinkCell3 linkRoute={REACT_APP_URL_PREFIX + `/calendar/carSurveys/${props.idArr[0]}/${name}/`}
                          linkTitle={name}/>
    }

    const statusCell = (props) => {
        return <StatusCell color={props.cellContent === 'Прошли' ? 'green' : 'red'} text={props.cellContent}/>
    }
	
	
    return (
        <OrgPage
            url={`${baseURL}${getAllCarSurveys(userId).api}`}
            firstRow={[{title: 'Название организации'}, {title: 'Дата выезда'}, {title: 'Статус'}]}

            haveToShow={[
                    {id: 'name', type: 'wrapperCell', idArr: ['id'], typeData: {cell: toOrganizationCallHistory}},
                    {id: 'date',type: 'wrapperCell', typeData: { 
                            cell: props => <div className={'row__cell'} style={{overflow: 'visible'}}>{props.cellContent}</div>
					} },
                    {id: 'status', type: 'wrapperCell', idArr: ['   id'], typeData: {cell: statusCell}}
                    ]}
            filterFieldsConf={{
                date: true,
                period: true,
                name: true,
            }}
            filterBarButtons={{
                downloadTemplate: {
                    show: false,
                    url: '/'
                }
            }}
            breadCrumbsItems={[{title: 'Каленадрь'}, {title: 'История выездов', actual: true}]}
        />

    );
}

export default AllCarSurveysHistory;